import React, { useEffect, useState } from "react";

const ImagePreview = ({
  item,
  itt,
  headImage,
  imgLength,
  ext,
  className,
  width,
  height,
  gap,
  fileSize,
  fileHeight,
}) => {
  const [imgSrc, setImageSrc] = useState(null);
  const [modal, setModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const getImageSrc = (src) => {
    setImageSrc(src);
    setModal(true);
  };

  useEffect(() => {
    const handleKeyEvent = (event) => {
      if (event.key === "Escape") {
        setModal(false);
      }
    };
    document.addEventListener("keydown", handleKeyEvent);
    return () => {
      document.removeEventListener("keydown", handleKeyEvent);
    };
  }, [setModal]);

  const downloadFilePreview = (src) => {
    window.open(src, "_target", "blank");
  };

  const closeImagePreview = () => {
    setModal(false);
  };
  // const handleNext = () => {
  //   setCurrentImageIndex((currentImageIndex + 1) % imgLength.length);
  //   setImageSrc(imgLength?.[currentImageIndex]?.file_url);
  // };

  // const handlePrev = () => {
  //   setCurrentImageIndex(
  //     (currentImageIndex + imgLength.length - 1) % imgLength.length
  //   );
  //   setImageSrc(imgLength?.[currentImageIndex]?.file_url);
  // };
  return (
    <div className="galler">
      <div className={`cu_modal ${modal ? "open" : ""}`}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-6 h-6"
          onClick={closeImagePreview}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>

        <img src={imgSrc} />
      </div>
      <div className={`modal_child ${className || ""}`}>
        {" "}
        {["jpeg", "jpg", "png", "gif", "JPG", "PNG", "JPEG"].includes(
          item?.["attachment"]?.[itt]?.file_name?.split(".")?.pop() ||
            headImage?.file_name?.split(".").pop() ||
            ext
        ) ? (
          <>
            {" "}
            <img
              src={
                item?.["attachment"]?.[itt]?.file_url ||
                headImage?.file_url ||
                headImage
              }
              style={{
                width: `${width || "89px"}`,
                height: `${height || "44px"}`,
                cursor: "pointer",
                marginBottom: `${gap}`,
              }}
              title={item?.["attachment"]?.[itt]?.file_name}
              onClick={() =>
                getImageSrc(
                  item?.["attachment"]?.[itt]?.file_url ||
                    headImage.file_url ||
                    headImage
                )
              }
            />
            {headImage?.file_name && (
              <figure className="text-center">
                {headImage?.file_name.slice(0, 6) +
                  "." +
                  headImage?.file_name.split(".").pop()}
              </figure>
            )}
          </>
        ) : (
          <a
            href={
              item?.["attachment"]?.[itt]?.file_url ||
              headImage?.file_url ||
              headImage
            }
            target="blank"
          >
            <span
              style={{
                display: "flex",
                justifyContent: "center",
                width: `${width || "89px"}`,
                height: `${fileHeight || height || "44px"}`,
                backgroundColor: "rgb(243 243 243)",
                alignItems: "center",
              }}
            >
              <i
                className="fa fa-file"
                style={{
                  fontSize: `${fileSize || "44px"}`,
                }}
              ></i>
            </span>

            {headImage?.file_name && (
              <figure className="text-center">
                {headImage?.file_name?.slice(0, 6) +
                  "." +
                  headImage?.file_name?.split(".").pop()}
              </figure>
            )}
          </a>
        )}
      </div>
    </div>
  );
};

export default ImagePreview;
